import { useNavigate, useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const FACTORS = [
  "Property size",
  "Number of movers required",
  "Truck requirements",
  "Moving distance",
  "Access conditions",
  "Stairs or lifts",
  "Moving date",
  "Additional services",
];

export const Pricing = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const lenis = useLenis();
  const goQuote = () => {
    if (pathname !== "/") {
      navigate("/#quote");
      return;
    }
    lenis?.scrollTo("#quote", { offset: -70 });
  };
  return (
    <section className="bg-blaze text-white" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:py-24 lg:px-10 lg:py-36">
        <div className="flex flex-wrap items-start justify-between gap-12">
          <Reveal delay={0.1}>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-white/70">Simple Moving. Clear Pricing.</p>
            <h2 className="font-display text-[13vw] font-semibold uppercase leading-[0.9] tracking-tighter sm:text-7xl lg:text-[7rem]" data-testid="pricing-rate">
              Moving From<br />$69<span className="ml-[0.12em] inline-block text-[0.35em] align-top">/hr*</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="max-w-xl">
            <p className="text-sm leading-relaxed text-white/85 md:text-base" data-testid="pricing-disclaimer">
              MoversNearby offers moving services starting from $69/hr* for eligible moving requirements.
              Your final moving cost can depend on factors such as:
            </p>
            <ul className="mt-5 flex flex-wrap gap-2" data-testid="pricing-factors">
              {FACTORS.map((f) => (
                <li key={f} className="flex items-center gap-1.5 rounded-full border border-white/30 px-3.5 py-1.5 text-xs font-medium text-white">
                  <Check className="h-3 w-3" /> {f}
                </li>
              ))}
            </ul>
            <p className="mt-5 text-sm leading-relaxed text-white/85">
              We&rsquo;ll discuss your requirements and help you understand the right moving option for your move.
            </p>
            <p className="mt-4 text-sm font-semibold text-white">
              Not sure what you need? That&rsquo;s okay. Tell us about your move and we&rsquo;ll help you work it out.
            </p>
            <button
              onClick={goQuote}
              data-testid="pricing-book-btn"
              className="group mt-8 flex items-center gap-3 rounded-lg bg-slate-900 px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:scale-[1.04] hover:bg-slate-800 hover:shadow-[0_12px_40px_rgba(15,23,42,0.35)]"
            >
              Get a Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.3}>
          <div className="relative mt-16 overflow-hidden rounded-2xl shadow-2xl" data-testid="pricing-image">
            <img src="/images/truck-road.png" alt="MoversNearby truck driving through Melbourne" className="h-60 w-full object-cover sm:h-80" loading="lazy" />
            <span className="absolute bottom-4 left-4 rounded-full bg-white/90 px-4 py-2 text-xs font-bold uppercase tracking-wider text-slate-900 shadow">
              On the road across Melbourne &amp; beyond
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
